// Generic segmented-button-group renderer used for the metric picker, month picker and the
// difference/absolute toggle. Plain DOM, fully re-rendered on every state change (a handful of
// buttons — cheap — unlike the per-PLZ feature-state loop, which never touches the DOM).

export interface SegmentedItem {
  value: string;
  label: string;
  title?: string;
}

export function renderSegmented(
  container: HTMLElement,
  items: SegmentedItem[],
  current: string,
  onSelect: (value: string) => void,
): void {
  container.innerHTML = "";
  for (const item of items) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.textContent = item.label;
    if (item.title) btn.title = item.title;
    const active = item.value === current;
    btn.className = "seg-btn" + (active ? " active" : "");
    btn.setAttribute("aria-pressed", String(active));
    btn.addEventListener("click", () => onSelect(item.value));
    container.appendChild(btn);
  }
}
